import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    fontSize: '1rem',
    textAlign: 'right',
    padding: '.25rem 0',
  },
  label: {
    fontWeight: 'bold',
  },
  services: {
    color: '#42a5f5 !important',
  },
  goods: {
    color: '#ffa726 !important',
  },
  value: {
    fontWeight: 'normal',
    width: '120px',
    display: 'inline-block',
    border: 'rgba(128, 128, 128, 0.2) solid 1px',
    borderRadius: '.5rem',
    padding: '.2rem',
    color: 'red',
    marginLeft: '1rem',
  },
  quote_block: {
    background: '#FFECB3',
    borderLeft: '.5rem solid #FFC107',
    padding: '1rem',
  },
}));

export default useStyles;
